// src/components/customers/tabs/tabs-History.jsx
import React, { useState } from "react";
import { useCustomerHistoryQuery, useAddCustomerHistoryMutation, useArchiveCustomerHistoryMutation } from "@queries/customers";
import { useQueryClient } from "@tanstack/react-query";

export default function HistoryTab({ customer }) {
  const id = customer?.customer_id || customer?.id;
  const { data, isLoading, isError } = useCustomerHistoryQuery(id);
  const addHistory = useAddCustomerHistoryMutation();
  const archiveHistory = useArchiveCustomerHistoryMutation();
  const queryClient = useQueryClient();
  
  const [comment, setComment] = useState("");

  const historyList = data?.data || [];

  const handleAddHistory = async () => {
    const payloadComment = comment.trim() === "" ? " " : comment;
    
    try {
      await addHistory.mutateAsync({
        id,
        payload: { comment: payloadComment }
      });
      setComment("");
      queryClient.invalidateQueries({ queryKey: ["customers", "history", id] });
    } catch (err) {
      console.error("Failed to add history", err);
      if (err?.response?.data?.message) {
        alert(`Error: ${err.response.data.message}`);
      } else if (err?.message) {
        alert(`Error: ${err.message}`);
      } else {
        alert("Failed to add history");
      }
    }
  };

  const handleArchive = async (historyId) => {
    if (!window.confirm("Are you sure you want to archive this history?")) return;
    try {
      await archiveHistory.mutateAsync({
        customerId: id,
        historyId
      });
      queryClient.invalidateQueries({ queryKey: ["customers", "history", id] });
    } catch (err) {
      console.error("Failed to archive history", err);
      alert("Failed to archive history");
    }
  };

  if (isLoading) return <div className="oc-empty">Loading history...</div>;
  if (isError) return <div className="oc-empty" style={{ color: "red" }}>Error loading history</div>;

  return (
    <div>
      <div className="oc-card" style={{ marginBottom: 20 }}>
        <div className="oc-header">
          <h2>History</h2>
        </div>
        <table className="oc-table">
          <thead>
            <tr>
              <th>Date Added</th>
              <th>Comment</th>
              <th>Archive History</th>
              <th>Created By</th>
            </tr>
          </thead>
          <tbody>
            {historyList.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">No history found</td>
              </tr>
            ) : (
              historyList.map((h) => (
                <tr key={h.customer_history_id || h.id} style={h.archived ? { backgroundColor: "#888888", color: "#333" } : {}}>
                  <td>{h.date_added}</td>
                  <td>{h.comment}</td>
                  <td>
                    {h.archived ? (
                      "Archived"
                    ) : (
                      <button 
                        className="oc-btn" 
                        style={{ backgroundColor: "white", color: "black", border: "1px solid #ccc" }}
                        onClick={() => handleArchive(h.customer_history_id || h.id)}
                        disabled={archiveHistory.isPending}
                      >
                        Archive History
                      </button>
                    )}
                  </td>
                  <td>
                    {h.archived ? (
                      `${h.archived_by} on ${h.archived_date_added}`
                    ) : (
                      h.created_by
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="oc-card">
        <div className="oc-header">
          <h2>Add History</h2>
        </div>
        <div className="oc-form-group">
          <label className="lbl">Comment</label>
          <textarea
            className="oc-input"
            rows="5"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Comment"
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ textAlign: "right", marginTop: 12 }}>
          <button 
            className="oc-btn" 
            onClick={handleAddHistory}
            disabled={addHistory.isLoading || !comment.trim()}
          >
            <i className="fa fa-plus" style={{ marginRight: 6 }} />
            Add History
          </button>
        </div>
      </div>
    </div>
  );
}

